import { dbSupabase, dbConfigured } from '../lib/dbClient';

// Read-only data access for the game, pointed at the EDITOR project's world
// data via the public_* views. The game never touches the base tables and
// never sees hidden fields (e.g. potential ability lives in public_players? No
// — it is deliberately excluded from the view). See SETUP-GAME-VIEWS.sql.

export { dbConfigured };

const NOT_CONFIGURED = { data: null, error: 'not-configured' };

export async function fetchClubs() {
  if (!dbSupabase) return NOT_CONFIGURED;
  return dbSupabase
    .from('public_clubs')
    .select('*')
    .order('tier')
    .order('name');
}

export async function fetchClub(id) {
  if (!dbSupabase) return NOT_CONFIGURED;
  return dbSupabase
    .from('public_clubs')
    .select('*')
    .eq('id', id)
    .maybeSingle();
}

// Finances live in their own view so the clubs view stays untouched. May return
// no row for clubs that predate the finance migration — callers handle null.
export async function fetchClubFinances(id) {
  if (!dbSupabase) return { data: null, error: null };
  return dbSupabase
    .from('public_club_finances')
    .select('*')
    .eq('id', id)
    .maybeSingle();
}

export async function fetchSquad(clubId) {
  if (!dbSupabase) return NOT_CONFIGURED;
  return dbSupabase
    .from('public_players')
    .select('*')
    .eq('club_id', clubId)
    .order('current_ability', { ascending: false });
}
